module.exports = __webpack_public_path__ + "img/extended.98cc3291.png";